__turbopack_context__.v({
  "location": "BrowseEventsInLocationSelector-module-scss-module__XMeK3W__location",
  "locationText": "BrowseEventsInLocationSelector-module-scss-module__XMeK3W__locationText",
});
